import { CONFIG } from '../../../../config'
import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import {
  parseToMysqlFormat,
  parseToMysqlFormatWithTime00,
  parseToMysqlFormatWithTime23,
} from '../../../util/date.service'
import * as deliveriesRoutes from '../../routes/deliveries.routes'
import { openReportInNewTab } from '../../../util/report.service'
import { getUsuarioInfo } from '../../../localstorage/localstorage.service'

const { ENVIROMENT } = CONFIG

const EstoqueHttp = {
  baseURL: `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/estoque`,
  apiURL: `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}`,

  async getEstoques(tpId) {
    try {
      const url = `${this.baseURL}/${tpId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async saveEstoque(tpId, data) {
    try {
      const response =
        typeof data.id !== 'undefined'
          ? await authHttp().put(`${this.baseURL}/update/${tpId}`, data)
          : await authHttp().post(`${this.baseURL}/create/${tpId}`, data)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async updateEstoque(tpId, data) {
    try {
      const url = `${this.baseURL}/update/${tpId}`
      const response = await authHttp().put(url, data)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async saveFotografiaEstoque(tpId, data) {
    try {
      const url = `${this.baseURL}/fotografia/update/${tpId}`
      const response = await authHttp().put(url, data)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async deleteEstoque(tpId, estoqueId) {
    try {
      const url = `${this.baseURL}/delete/${tpId}/${estoqueId}`
      const response = await authHttp().delete(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getPosicoesEstoques(tpId, estoqueId) {
    try {
      const url = `${this.baseURL}/posicoes/${tpId}/${estoqueId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getPosicoesEstoquesDiarioRelatorio(estoqueIds, company_ids, pInicial, pFinal) {
    try {
      const estoques = Array.isArray(estoqueIds) ? estoqueIds.join(',') : String(estoqueIds || '')
      const url = `${this.baseURL}/relatorio/posicao-diaria/${estoques}?company_ids=${company_ids}&pInicial=${pInicial}&pFinal=${pFinal}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getPosicoesEstoquesById(tpId, estoqueId) {
    try {
      const url = `${this.baseURL}/posicoes-estoque/${tpId}/${estoqueId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getPosicoesEstoquesRelatorioInventario(tpId, estoqueId, pInicial, pFinal) {
    try {
      const url = `${this.baseURL}/inventario/historico-por-posicao/${tpId}/${estoqueId}?pInicial=${parseToMysqlFormat(pInicial)}&pFinal=${parseToMysqlFormat(pFinal)}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getRelatorioRecallProduto(tpId, estoqueId, produtoId, pInicial, pFinal) {
    try {
      const url = `${this.baseURL}/inventario/relatorio-recall-produto/${tpId}/${estoqueId}/${produtoId}?pInicial=${parseToMysqlFormat(pInicial)}&pFinal=${parseToMysqlFormat(pFinal)}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async savePosicaoEstoque(tpId, data) {
    try {
      const response =
        typeof data.id !== 'undefined'
          ? await authHttp().put(`${this.baseURL}/posicao/update/${tpId}`, data)
          : await authHttp().post(`${this.baseURL}/posicao/create/${tpId}`, data)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async savePosicoesEstoque(tpId, data) {
    try {
      const response = await authHttp().post(`${this.baseURL}/posicao/create/excel/${tpId}`, data)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async updatePosicoesEstoque(tpId, data) {
    try {
      const url = `${this.baseURL}/posicoes/update/${tpId}`
      const response = await authHttp().put(url, data)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async updatePosicoesEstoqueFromExcel(tpId, estoqueId, posicoes) {
    try {
      const url = `${this.baseURL}/posicoes/update/excel/${tpId}`
      const response = await authHttp().put(url, { estoque_id: estoqueId, posicoes })
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async deletePosicaoEstoque(tpId, posicaoId) {
    try {
      const url = `${this.baseURL}/posicao/delete/${tpId}/${posicaoId}`
      const response = await authHttp().delete(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async deletePosicoesEstoque(tpId, selectedPosicoesIds) {
    try {
      const url = `${this.baseURL}/posicao/delete/multiples/${tpId}/${selectedPosicoesIds.toString()}`
      const response = await authHttp().delete(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  getUrlTagPosicoes(tpId, posicoes) {
    return `${this.baseURL}/posicao/tags/${tpId}?posicoes_ids=${posicoes}&t=${localStorage.getItem('t')}`
  },

  getUrlTagPosicoesHorizontal(tpId, posicoes) {
    return `${this.baseURL}/posicao/tags-horizontal/${tpId}?posicoes_ids=${posicoes}&t=${localStorage.getItem('t')}`
  },

  getUrlTagPosicoesFullHorizontal(tpId, posicoes) {
    return `${this.baseURL}/posicao/tags-horizontal-full/${tpId}?posicoes_ids=${posicoes}&t=${localStorage.getItem('t')}`
  },
  
  async getOperacoesEstoque(tpId) {
    try {
      const url = `${this.baseURL}/operacoes/${tpId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getOperacoesEstoqueEntrada(tpId) {
    try {
      const url = `${this.baseURL}/operacoes/entrada/${tpId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getOperacoesEstoqueSaida(tpId) {
    try {
      const url = `${this.baseURL}/operacoes/saida/${tpId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getOperacoesEstoqueTransferencia(tpId) {
    try {
      const url = `${this.baseURL}/operacoes/transferencia/${tpId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async deleteOperacaoEstoque(tpId, opId) {
    try {
      const url = `${this.baseURL}/operacoes/delete/${tpId}/${opId}`
      const response = await authHttp().delete(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async deleteOperacaoEstoqueTransferencia(tpId, opId) {
    try {
      const url = `${this.baseURL}/operacoes/transferencia/delete/${tpId}/${opId}`
      const response = await authHttp().delete(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getProdutosOnPosicaoEstoque(tpId, posicao_id) {
    try {
      const url = `${this.baseURL}/posicoes/${tpId}/produtos/${posicao_id}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getPalletsOnPosicaoEstoque(tpId, posicao_id) {
    try {
      const url = `${this.baseURL}/posicoes/${tpId}/pallets/${posicao_id}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getPalletsStatus(posicaoId) {
    try {
      const url = `${this.baseURL}/pallets-status/${posicaoId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getInfoPalletStatus(tpId, palletAreaId) {
    try {
      const url = `${this.baseURL}/info-pallet-status/${tpId}/${palletAreaId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async savePalletAreaStatus(
    userId,
    palletAreaId,
    { status_estoque_id, missing_reason_id = null },
  ) {
    try {
      const url = `${this.baseURL}/pallet-status/${userId}/${palletAreaId}`
      const response = await authHttp().post(url, {
        status_estoque_id,
        missing_reason_id,
      })
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async saveOperacaoEstoqueEntradaSaida(tpId, data) {
    try {
      const postData = {
        id: data.id,
        name: data.name,
        type: data.selectedType,
        tp_id: tpId,
        entrada_aplicativo: data.entrada_aplicativo,
        entrada: data.selectedOperacaoEntrada,
        saida: data.selectedOperacaoSaida,
        grupo_de_operacao: data.grupo_de_operacao,
      }
      const response = data.id
        ? await authHttp().put(`${this.baseURL}/operacoes/update/${tpId}`, postData)
        : await authHttp().post(`${this.baseURL}/operacoes/create/${tpId}`, postData)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getMovimentacoesEstoque(tpId, pInicial, pFinal) {
    try {
      const url = `${this.baseURL}/${tpId}?pInicial=${parseToMysqlFormatWithTime00(pInicial)}&pFinal=${parseToMysqlFormatWithTime23(pFinal)}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async saveMovimentacoesEstoque(tpId, data) {
    try {
      const url =
        typeof data.id !== 'undefined'
          ? `${this.baseURL}/update/${tpId}`
          : `${this.baseURL}/create/${tpId}`
      const response = await authHttp().post(url, data)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async updateMovimentacoesEstoque(tpId, data) {
    try {
      const url = `${this.baseURL}/update/${tpId}`
      const response = await authHttp().put(url, data)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  //********* MOVIMENTCAO EXPEDICAO

  async associarPosicoesFIFO(expedicaoId, tpId, estoquesIds) {
    try {
      const url = `${this.baseURL}/movimentacao/expedicao/expedir/fifo/${tpId}/${expedicaoId}/${estoquesIds}`
      const response = await authHttp().post(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getMovimentacoesExpedicao(tpId, pInicial, pFinal) {
    try {
      const url = `${this.baseURL}/movimentacao/expedicao/${tpId}?pInicial=${pInicial}&pFinal=${pFinal}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getMovimentacaoExpedicaoByIdentifier(tpId, identifier, pInicial, pFinal) {
    try {
      const url = `${this.baseURL}/movimentacao/expedicao-by-identifier/${tpId}/${encodeURIComponent(identifier)}?pInicial=${pInicial}&pFinal=${pFinal}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getClientesAssocToTpAndCompany(tpId, companyId) {
    try {
      const url = `${this.baseURL}/movimentacao/expedicao/clients/${tpId}/${companyId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async createMovimentacaoExpedicao(tpId, data) {
    try {
      const url = `${this.baseURL}/movimentacao/expedicao/create/${tpId}`
      const response = await authHttp().post(url, data)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async updateMovimentacaoExpedicao(tpId, data) {
    try {
      const url = `${this.baseURL}/movimentacao/expedicao/update/${tpId}`
      const response = await authHttp().put(url, data)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async deleteMovimentacaoExpedicao(tpId, expedicaoId, pInicial, pFinal) {
    try {
      const url = `${this.baseURL}/movimentacao/expedicao/delete/${tpId}/${expedicaoId}?pInicial=${pInicial}&pFinal=${pFinal}`
      const response = await authHttp().delete(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getExpedicaoInfo(tpId, expedicaoId) {
    try {
      const url = `${this.baseURL}/movimentacao/expedicao/import/info/${tpId}/${expedicaoId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async importExpedicaoXml(tpId, expedicaoId, fileTypeId, xmlData) {
    try {
      const url = `${this.baseURL}/movimentacao/expedicao/import-file-info/${tpId}/${expedicaoId}/${fileTypeId}`
      const response = await authHttp().post(url, xmlData)
      return response.data
    } catch (error) {
      throw error.response.data
    }
  },

  async getProdutosFromExpedicaoId(tpId, expedicaoId) {
    try {
      const url = `${this.baseURL}/movimentacao/expedicao/produtos/${tpId}/${expedicaoId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getProdutosFromEstoqueParaExpedir(tpId, expedicaoId, productId) {
    try {
      const url = `${this.baseURL}/movimentacao/expedicao/produtos/estoque/${tpId}/${expedicaoId}/${productId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getPalletsFromEstoqueParaExpedir(tpId, expedicaoId, productId) {
    try {
      const url = `${this.baseURL}/movimentacao/expedicao/pallets/estoque/${tpId}/${expedicaoId}/${productId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async postExpedirProduto(tpId, productId, expedicaoId, data) {
    try {
      const url = `${this.baseURL}/movimentacao/expedicao/expedir/${tpId}/${expedicaoId}/${productId}`
      const response = await authHttp().post(url, data)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async createConferenciaExpedicao(tpId, expedicaoId) {
    try {
      const url = `${this.baseURL}/movimentacao/expedicao/conferir/${tpId}/${expedicaoId}/${getUsuarioInfo().id}`
      const response = await authHttp().post(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  emitirRelatorio(tpId, expedicaoId) {
    const url =
      this.baseURL +
      `/movimentacao/expedicao/relatorio/${tpId}/${expedicaoId}?t=${localStorage.getItem('t')}`
    openReportInNewTab(url)
  },

  async emitirExpedicaoDaMovimentacao(tpId, expedicaoId) {
    try {
      const url = `${this.baseURL}/movimentacao/expedicao/emitir-expedicao/${tpId}/${expedicaoId}`
      const response = await authHttp().post(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async reabrirMovimentacaoExpedicao(tpId, expedicaoId) {
    try {
      const url = `${this.baseURL}/movimentacao/expedicao/reabrir/${tpId}/${expedicaoId}/${getUsuarioInfo().id}`
      const response = await authHttp().put(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async finalizarMovimentacaoExpedicao(tpId, expedicaoId) {
    try {
      const url = `${this.baseURL}/movimentacao/expedicao/finalizar/${tpId}/${expedicaoId}/${getUsuarioInfo().id}`
      const response = await authHttp().post(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getHistoricoConferenciaExpedicao(tpId, expedicaoId) {
    try {
      const url = `${this.baseURL}/movimentacao/expedicao/historico-conferencia/${tpId}/${expedicaoId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async importExpedicaoManual(tpId, expedicaoId, items, identifier) {
    try {
      const url = `${this.baseURL}/movimentacao/expedicao/import-manual/${tpId}/${expedicaoId}`
      const response = await authHttp().post(url, { items, identifier })
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  //********* AVULSO

  async getPosicoesWhereProdutoIn(tpId, productId) {
    try {
      const url = `${this.baseURL}/movimentacao/avulso/produtos/${tpId}/${productId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getMovimentacoesAvulsoOnPeriodo(tpId, dataInicial, dataFinal, selectedOperacaoId) {
    try {
      const url = `${this.baseURL}/movimentacao/avulso/${tpId}?dataInicial=${dataInicial}&dataFinal=${dataFinal}&operacaoId=${selectedOperacaoId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  emitirRelatorioAvulso(tpId, movimentacoesIds, operacaoId) {
    const url =
      this.baseURL +
      `/movimentacao/avulso/relatorio/${tpId}?t=${localStorage.getItem('t')}&movimentacoes_ids=${movimentacoesIds.toString()}&operacao_id=${operacaoId}`
    openReportInNewTab(url)
  },

  async createMovimentacaoAvulsoEntrada(tpId, data) {
    try {
      const url = `${this.baseURL}/movimentacao/avulso/entrada/${tpId}`
      const response = await authHttp().post(url, data)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async createMovimentacaoAvulsoExpedicao(tpId, data) {
    try {
      const url = `${this.baseURL}/movimentacao/avulso/saida/${tpId}`
      const response = await authHttp().post(url, data)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  //********* VER ESTOQUE

  async getProdutosOnPosicaoEstoqueVisualizer(tpId, posicaoId) {
    try {
      const url = `${this.baseURL}/posicoes/${tpId}/produtos/visualizer/${posicaoId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  //********* RELATORIO ESTADIA

  async getPosicoesEstoqueForRelatorioEstadia(tpId, companyId) {
    try {
      const url = `${this.baseURL}/relatorio/estadia/${tpId}/${companyId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getProdutosFromPosicaoEstoqueForRelatorio(tpId, posicaoId) {
    try {
      const url = `${this.baseURL}/relatorio/estadia/produtos/${tpId}/${posicaoId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  getRelatorioEstadiaExcel(tpId, companyId) {
    return `${this.baseURL}/relatorio/estadia/excel/${tpId}/${companyId}?t=${localStorage.getItem('t')}`
  },

  //********* RELATORIO ESTOQUE POR PRODUTO
  async getRelatorioEstoquePorProduto(tpId) {
    try {
      const url = `${this.baseURL}/relatorio-estoque-por-produto/${tpId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getComparativoEntradaAvulsoPicking(tpId, pickingId) {
    try {
      const url = `${this.baseURL}/comparativo-entrada-avulso-picking/${tpId}/${pickingId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getPickingsComparativoEntradaAvulso(companyId, tpId, dataInicio, dataFim) {
    try {
      const url =
        `${this.baseURL}/comparativo-entrada-avulso-picking/pickings/${tpId}/${companyId}` +
        `?data_inicio=${dataInicio}&data_fim=${dataFim}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  //********* CONSUMOS
  async getInventariosOnPeriodo(selectedTp, pInicial, pFinal) {
    try {
      const url = `${this.baseURL}/inventario/${selectedTp}?periodo_inicial=${pInicial}&periodo_final=${pFinal}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getInventarioById(selectedTp, inventarioId) {
    try {
      const url = `${this.baseURL}/inventario/${selectedTp}/${inventarioId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async saveInventario(selectedTp, data, pInicial, pFinal) {
    try {
      const url = `${this.baseURL}/inventario/${selectedTp}?periodo_inicial=${pInicial}&periodo_final=${pFinal}`
      const response = data.id ? await authHttp().put(url, data) : await authHttp().post(url, data)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async deleteInventario(selectedTp, inventarioId, userId, pInicial, pFinal) {
    try {
      const url = `${this.baseURL}/inventario/${selectedTp}/${inventarioId}/${userId}?periodo_inicial=${pInicial}&periodo_final=${pFinal}`
      const response = await authHttp().delete(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getPosicoesEstoqueToAssoc(selectedTp, estoqueId, inventarioId) {
    try {
      const query = inventarioId ? `?inventario_id=${inventarioId}` : ''
      const url = `${this.baseURL}/inventario/posicoes-estoques-disponiveis/${selectedTp}/${estoqueId}${query}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getPosicoesEstoqueAssoc(selectedTp, inventarioId) {
    try {
      const url = `${this.baseURL}/inventario/posicoes-estoques-em-inventario/${selectedTp}/${inventarioId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getProdutosAssociacaoAutomaticaInventario(companyId) {
    try {
      const url = `${this.baseURL}/inventario/produtos-associacao-automatica/${companyId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async associarPosicoesToInventario(selectedTp, inventarioId, estoqueId, posicoesIds) {
    try {
      const url = `${this.baseURL}/inventario/associar-posicao-estoque/${selectedTp}`
      const response = await authHttp().post(url, {
        inventario_id: inventarioId,
        estoque_id: estoqueId,
        posicoes_estoque_id: posicoesIds,
      })
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async associarPosicoesToInventarioByProductMovement(
    selectedTp,
    inventarioId,
    estoqueId,
    productId,
    pInicial,
    pFinal,
  ) {
    try {
      const url = `${this.baseURL}/inventario/associar-posicoes-produto-periodo/${selectedTp}`
      const response = await authHttp().post(url, {
        inventario_id: inventarioId,
        estoque_id: estoqueId,
        product_id: productId,
        periodo_inicial: pInicial,
        periodo_final: pFinal,
      })
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async desassociarPosicoesToInventario(selectedTp, inventarioId, posicoesIds) {
    try {
      const url = `${this.baseURL}/inventario/desassociar-posicao-estoque/${selectedTp}`
      const response = await authHttp().post(url, {
        inventario_id: inventarioId,
        posicoes_estoque_id: posicoesIds,
      })
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async createConferenciaInventarioFromPosicoes(selectedTp, selectedInventarioId, posicoesIds) {
    try {
      const url = `${this.baseURL}/inventario/criar-conferencia/${selectedTp}`
      const response = await authHttp().post(url, {
        inventario_id: selectedInventarioId,
        posicoes_estoque_id: posicoesIds,
      })
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getConferenciasFromPosicao(selectedTp, inventarioId, posicaoId) {
    try {
      const url = `${this.baseURL}/inventario/conferencias/${selectedTp}?inventario_id=${inventarioId}&posicao_estoque_id=${posicaoId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getPosicoesWithLastConferenciaFromInventario(selectedTp, selectedInventarioId) {
    try {
      const url = `${this.baseURL}/inventario/resultado-inventario/${selectedTp}/${selectedInventarioId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getProdutosFromConferenciaPosicaoOnInventario(selectedTp, conferenciaId) {
    try {
      const url = `${this.baseURL}/inventario/conferencia-items/${selectedTp}/${conferenciaId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async imprimirPosicoesConferencia(tpId, inventarioId) {
    const url =
      this.baseURL +
      `/inventario/resultado-acerto/${tpId}/${inventarioId}?t=${localStorage.getItem('t')}`
    openReportInNewTab(url)
  },

  async acertoConferenciaProdutos(selectedTp, inventarioId, body) {
    try {
      const url = `${this.baseURL}/inventario/acerto/${selectedTp}/${inventarioId}/${getUsuarioInfo().id}`
      const response = await authHttp().post(url, body)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async zerarPosicoesRestantes(selectedTp, inventarioId, userId) {
    try {
      const url = `${this.baseURL}/inventario/zerar-posicoes-restantes/${selectedTp}/${inventarioId}/${userId}`
      const response = await authHttp().put(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  //********* CONSUMOS

  async getDeliveriesCyclesRecebimentoByOpCenterID(opCenterId) {
    try {
      const response = await authHttp().get(
        deliveriesRoutes.urlGetDeliveriesCycleRecebimentoByOpCenterId(opCenterId),
      )
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getPickingsByDeliveriesTpId(tpId, pInicial, pFinal) {
    try {
      const response = await authHttp().get(
        `${this.apiURL}/picking/pickings-by-delivery-cycle/${tpId}?pInicial=${pInicial}&pFinal=${pFinal}`,
      )
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getPalletsAreaByPickingId(pickingId) {
    try {
      const response = await authHttp().get(`${this.apiURL}/picking/pallets-area/${pickingId}`)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getProdutosByPickingId(pickingId) {
    try {
      const response = await authHttp().get(
        `${this.apiURL}/picking/produtos-para-estocar/${pickingId}`,
      )
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getPalletAreasProdutosByPickingId(pickingId) {
    try {
      const response = await authHttp().get(
        `${this.apiURL}/picking/produtos-pallet-para-estocar/${pickingId}`,
      )
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async postMovimentacaoEstoqueRecebimento(data, tpId, userId) {
    try {
      const response = await authHttp().post(
        `${this.baseURL}/movimentacao/recebimento/create/${tpId}/${userId}`,
        data,
      )
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async postMovimentacaoEstoqueTransferencia(data, tpId) {
    try {
      const response = await authHttp().post(
        `${this.baseURL}/movimentacao/transferencia/create/${tpId}`,
        data,
      )
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  // Movimentação por Tipo Operação

  async getMovimentacaoPorTipoOperacao(
    tpId,
    tipoOperacao,
    empresaId,
    pInicial,
    pFinal,
    operacaoId,
    estoqueId,
  ) {
    try {
      const response = await authHttp().get(
        `${this.baseURL}/inventario/movimentacao-por-tipo-operacao/${tpId}/${empresaId}?pInicial=${pInicial}&pFinal=${pFinal}&tipoOperacao=${tipoOperacao}&operacao_estoque_id=${operacaoId}&estoque_id=${estoqueId}`,
      )
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  // Movimentação por Posição

  async getMovimentacaoPorPosicao(tpId, posicaoId, pInicial, pFinal) {
    try {
      const response = await authHttp().get(
        `${this.baseURL}/inventario/extrato-movimentacao-posicao-estoque/${tpId}/${posicaoId}?pInicial=${pInicial}&pFinal=${pFinal}`,
      )
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  // Motivos Bloqueio Posição de Estoque

  async getMotivosBloqueioPosicaoEstoque(tpId) {
    try {
      const response = await authHttp().get(`${this.baseURL}/posicoes-motivo-bloqueio/${tpId}`)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async saveMotivosBloqueioPosicaoEstoque(tpId, motivo) {
    try {
      const response = await authHttp().post(
        `${this.baseURL}/posicoes-motivo-bloqueio/${tpId}`,
        motivo,
      )
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async updateMotivosBloqueioPosicaoEstoque(tpId, motivo) {
    try {
      const response = await authHttp().put(
        `${this.baseURL}/posicoes-motivo-bloqueio/${tpId}`,
        motivo,
      )
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async deleteMotivosBloqueioPosicaoEstoque(tpId, motivo) {
    try {
      const response = await authHttp().delete(
        `${this.baseURL}/posicoes-motivo-bloqueio/${tpId}/${motivo.id}`,
      )
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  // Bloqueio e Desbloqueio Posicao Estoque

  async blockPosicoesEstoque(tpId, posicoesEstoqueIds, motivoId, justificativaBloqueio, estoqueId) {
    try {
      const response = await authHttp().post(
        `${this.baseURL}/posicoes-bloquear/${tpId}/${getUsuarioInfo().id}`,
        { posicoesEstoqueIds, motivoId, justificativaBloqueio, estoqueId },
      )
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async unblockPosicoesEstoque(tpId, posicoesEstoqueIds) {
    try {
      const response = await authHttp().post(`${this.baseURL}/posicoes-desbloquear/${tpId}`, {
        posicoesEstoqueIds,
      })
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async historicoBlockPosicoesEstoque(tpId, posicaoId) {
    try {
      const response = await authHttp().get(
        `${this.baseURL}/posicoes-bloqueio-historico/${tpId}/${posicaoId}`,
      )
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  // Relatorio Saldo de Estoques
  async getRelatorioSaldoEstoque(tpId, estoquesIds, checkpoint) {
    try {
      const response = await authHttp().get(
        `${this.baseURL}/inventario/relatorio-saldo-estoque/${tpId}/${estoquesIds.toString()}?checkpoint=${parseToMysqlFormat(checkpoint)}`,
      )
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getEtiquetasInternadasEstoque(tp_id, posicoesEstoque) {
    try {
      const response = await authHttp().get(
        `${this.baseURL}/report-mapa-etiquetas-internadas-estoque-excel/${tp_id}?posicoes_estoque=${posicoesEstoque}`,
      )
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  urlReportEtiquetasInternadasEstoque(tp_id, posicoesEstoque) {
    return `${this.baseURL}/report-mapa-etiquetas-internadas-estoque/${tp_id}?posicoes_estoque=${posicoesEstoque}&t=${localStorage.getItem('t')}`
  },

  urlReportPosicoesEstoqueOcupadasDiaria(tpId, estoquesIds, companyIds, pInicial, pFinal) {
    const estoques = Array.isArray(estoquesIds) ? estoquesIds.join(',') : String(estoquesIds || '')
    const companies = Array.isArray(companyIds) ? companyIds.join(',') : String(companyIds || '')
    return (
      `${this.baseURL}/report-diaria-posicoes-estoque-ocupadas/${tpId}` +
      `?estoques_ids=${encodeURIComponent(estoques)}` +
      `&company_ids=${encodeURIComponent(companies)}` +
      `&pInicial=${pInicial}` +
      `&pFinal=${pFinal}` +
      `&t=${localStorage.getItem('t')}`
    )
  },

  urlReportPosicoesEstoqueOcupadasDiariaGrafico(tpId, estoquesIds, companyIds, pInicial, pFinal) {
    const estoques = Array.isArray(estoquesIds) ? estoquesIds.join(',') : String(estoquesIds || '')
    const companies = Array.isArray(companyIds) ? companyIds.join(',') : String(companyIds || '')
    return (
      `${this.baseURL}/report-diaria-posicoes-estoque-ocupadas-grafico/${tpId}` +
      `?estoques_ids=${encodeURIComponent(estoques)}` +
      `&company_ids=${encodeURIComponent(companies)}` +
      `&pInicial=${pInicial}` +
      `&pFinal=${pFinal}` +
      `&t=${localStorage.getItem('t')}`
    )
  },

  urlReportPosicoesEstoqueOcupadasDiariaPorPosicao(
    tpId,
    estoquesIds,
    companyIds,
    pInicial,
    pFinal,
  ) {
    const estoques = Array.isArray(estoquesIds) ? estoquesIds.join(',') : String(estoquesIds || '')
    const companies = Array.isArray(companyIds) ? companyIds.join(',') : String(companyIds || '')
    return (
      this.baseURL +
      '/report-diaria-posicoes-estoque-ocupadas-por-posicao/' +
      tpId +
      '?estoques_ids=' +
      encodeURIComponent(estoques) +
      '&company_ids=' +
      encodeURIComponent(companies) +
      '&pInicial=' +
      pInicial +
      '&pFinal=' +
      pFinal +
      '&t=' +
      localStorage.getItem('t')
    )
  },

  async getExtratoMovimentacaoProdutoEmExcelUrl(tp_id, product_id, data_inicial, data_final) {
    try {
      const url = `${this.baseURL}/extrato-movimentacao-produto-em-excel/${tp_id}`
      const response = await authHttp().get(url, {
        params: { product_id, data_inicial, data_final },
        timeout: 20000,
      })
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  // Ordem de Carregamento - Prevista
  async getOcPrevistas(tpId, companyId) {
    try {
      const query = companyId ? `?company_id=${companyId}` : ''
      const url = `${this.baseURL}/oc-previstas/${tpId}${query}`
      const { data } = await authHttp().get(url)
      return data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async saveOcPrevista(payload) {
    try {
      const body = { ...payload }
      if (body.data_expedicao) {
        body.data_expedicao = parseToMysqlFormat(body.data_expedicao)
      } else {
        delete body.data_expedicao
      }
      delete body.status
      const url = `${this.baseURL}/oc-prevista`
      const { data } = await authHttp().post(url, body)
      return data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async updateOcPrevista(id, payload) {
    try {
      const body = { ...payload }
      if (body.data_expedicao) {
        body.data_expedicao = parseToMysqlFormat(body.data_expedicao)
      } else {
        delete body.data_expedicao
      }
      delete body.status
      const url = `${this.baseURL}/oc-prevista/${id}`
      const { data } = await authHttp().put(url, body)
      return data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getOcPrevistasNotAssociated(tpId, companyId) {
    try {
      const url = `${this.baseURL}/oc-previstas-notAssociated/${tpId}/${companyId}`
      const { data } = await authHttp().get(url)
      return data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getStatusEtiquetaEstoque(tpId) {
    try {
      const response = await authHttp().get(`${this.baseURL}/status-etiqueta/${tpId}`)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async saveStatusEtiquetaEstoque(tpId, payload) {
    try {
      const response = await authHttp().post(`${this.baseURL}/status-etiqueta/${tpId}`, payload)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async updateStatusEtiquetaEstoque(tpId, payload) {
    try {
      const response = await authHttp().put(`${this.baseURL}/status-etiqueta/${tpId}`, payload)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async updatePosicaoEstoqueItem(tpId, itemId, data) {
    try {
      const url = `${this.baseURL}/posicao-item/update/${tpId}/${itemId}`
      const userId = getUsuarioInfo().id
      const response = await authHttp().put(url, { ...data, user_id: userId })
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getRelatorioPosicoesEtiquetasCliente(tpId) {
    try {
      const url = `${this.baseURL}/relatorio/posicoes-etiquetas-cliente/${tpId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getRelatorioPosicoesEtiquetasClienteExcel(tpId) {
    try {
      const url = `${this.baseURL}/relatorio/posicoes-etiquetas-cliente-excel/${tpId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getRelatorioPosicoesEtiquetasClienteNotas(tpId, clientId) {
    try {
      const url = `${this.baseURL}/relatorio/posicoes-etiquetas-cliente/${tpId}/${clientId}/notas`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getRelatorioPosicoesEtiquetasClienteEtiquetas(tpId, clientId) {
    try {
      const url = `${this.baseURL}/relatorio/posicoes-etiquetas-cliente/${tpId}/${clientId}/etiquetas`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
}

export default EstoqueHttp
